
<template>
  <div class="rightContent">
    <!-- 公司福利 -->
    <template v-if="companyTabIndex===2">
      <div class="header">
        <div class="title f_16 color_40 font_w_b">公司福利</div>
        <div class="tips f_12 color_60">标准时间和公司福利仅为求职者参考，不代表公司所有职位状况</div>
      </div>
      <div class="dataForm">
        <div class="item flex w450" :class="[errorTips.time?'error':'']" >
          <div class="formTitle color_9c f_14 pr">工作时间：<span class="pa">*</span></div>
          <div class="flex1">
            <div>
              <el-select v-model="company_data.benefits.start_at" @change="inputFocus('time');getEndTimeOptions(true)" placeholder="请选择" class="timeSelect f_14 color_40">
                <el-option
                  v-for="item in start_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="company_data.benefits.end_at" @change="inputFocus('time')" placeholder="请选择" class="timeSelect f_14 color_40">
                <el-option
                  v-for="item in end_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <!-- 错误提示 -->
            <div class="errorTipsDesc f_14" v-if="errorTips.time">
              <span class="iconfont icontishi"></span>
              <span class="tipsName">{{errorTips.time}}</span>
            </div>
          </div>
        </div>
        <div class="item flex" >
          <div class="formTitle color_9c f_14">加班情况：</div>
          <div class="flex1">
            <div class="clearfix">
              <div class="benefitItem fl f_14 text_center cursor_p transition_2" :class="[company_data.benefits.overtime === item.value?'active color_blue':'color_40']" v-for="(item,index) in company_options.overtime_options" :key="String(index)" @click="company_data.benefits.overtime = item.value">{{item.label}}</div>
            </div>
          </div>
        </div>
        <div class="item flex" >
          <div class="formTitle color_9c f_14">休息时间：</div>
          <div class="flex1">
            <div class="clearfix">
              <div class="benefitItem fl f_14 text_center cursor_p transition_2" :class="[company_data.benefits.rest === item.value?'active color_blue':'color_40']" v-for="(item,index) in company_options.rest_options" :key="String(index)" @click="company_data.benefits.rest = item.value">{{item.label}}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 福利 -->
      <div class="benefitDetail clearfix">
        <template v-for="item in company_options.benefit_options">
          <template v-for="sitem in item.list">
            <div class="item flex-c pr transition_2" :key="String(sitem.iconfont)" v-if="isCurrent(sitem,company_data.benefits.benefit_detail)" >
              <div class="icon iconfont color_60" :class="[sitem.iconfont]"></div>
              <div class="flex1">
                <div class="title f_14 color_40">{{sitem.label}}</div>
                <div class="desc f_12 color_9c ellipsis2">{{sitem.desc}}</div>
              </div>
              <div class="del iconfont iconGroup3 color_blue pa cursor_p" @click="deleteBenefit(sitem)"></div>
            </div>
          </template>
        </template>
        <div class="item cursor_p flex-c transition_2" @click="saveBenefit(true)">
          <div class="add icon iconfont iconjia1 color_cf"></div>
          <div class="flex1">
            <div class="title f_14 color_40">添加福利</div>
            <div class="desc f_12 color_9c ellipsis2">如：五险一金，定期体检等</div>
          </div>
        </div>
      </div>
      <div class="saveButton bg_current color_fff f_14 cursor_p fr text_center" @click="saveForm"><span class="el-icon-loading" v-if="saveFormState"></span> 保存</div>
    </template>
    
    <!-- 选择福利弹窗 -->
    <div class="benefitDetailBlock" v-if="showBenefitState">
      <div class="content pa bg_fff">
        <div class="bTitle f_18 color_40 font_w_b">
          选择福利
          <span class="iconfont iconquxiao fr cursor_p color_90" @click="closeBenefit"></span>
        </div>
        <div class="listOver">
          <template v-for="(item,index) in company_options.benefit_options">
            <div class="list" :key="String(index)">
              <div class="listTitle pr">{{item.label}}</div>
              <div class="clearfix">
                <template v-for="sitem in item.list">
                  <div class="item flex-c pr cursor_p transition_2" :class="[isCurrent(sitem,benefit_detail)?'current':'']" :key="String(sitem.iconfont)" @click="benefitChange(sitem)" >
                    <div class="icon iconfont color_60" :class="[sitem.iconfont]"></div>
                    <div class="flex1">
                      <div class="title f_14 color_40">{{sitem.label}}</div>
                      <div class="desc f_12 color_9c ellipsis2">{{sitem.desc}}</div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
        <div class="contentFooter bg_fff flex-c">
          <div class="name f_14 color_40">已选择：</div>
          <div class="clearfix flex1 currentList">
            <template v-for="item in company_options.benefit_options">
              <template v-for="sitem in item.list">
                <div class="title f_14 color_40 fl pr" v-if="isCurrent(sitem,benefit_detail)" :key="String(sitem.iconfont)">
                  {{sitem.label}}
                  <div class="iconfont iconguanbi pa color_9c cursor_p" @click="benefitChange(sitem)"></div>
                </div>
              </template>
            </template>
          </div>
          <div class="saveButton bg_current color_fff f_14 cursor_p fr text_center" @click="saveBenefit(false)">确认添加</div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  const _ = require('lodash');
  // 所有接口
  import actions from '@/actions/index'
  import { mapState, mapMutations } from 'vuex'
  import company_options from '@/utils/company_options'
  export default {
    name: 'companyRightContent2',
    props: {},
    data() {
      return {
        company_data:{
          benefits:{
            benefit_detail:[], //选中的福利
          }
        },
        benefit_detail:[], //福利弹窗中选中的福利
        errorTips:{ //错误提示
          time:'',
        },
        company_options:{},
        start_options:[], //开始时间数据
        end_options:[], //结束时间数据

        showBenefitState:false,//是否显示福利弹窗
        saveFormState:false, //是否正在保存
      }
    },
    created() {
      //同步下拉菜单数据
      this.company_options = company_options;
      //获取时间Options
      this.getstartTimeOptions();
    },

    computed: {
      ...mapState('company', ['companyData', 'companyTabIndex']),
    },
    methods: {
      ...mapMutations('company',['updateCompanyData','updateCompanyTabIndex']),
      getstartTimeOptions(){
        let start_options = [];
        for(let i=0; i<24; i++){
          start_options.push({
            value:`${i}:00`,
            label:`${i}:00`,
          })
          start_options.push({
            value:`${i}:30`,
            label:`${i}:30`,
          })
        }
        this.start_options = start_options;
      },
      //获取结束时间数组
      getEndTimeOptions(updateEndAt){
        let { start_at, end_at } = this.company_data.benefits;
        let start_at_index = 0; //选中的index
        let halfAnHour = false; //是否是半小时
        let end_options = [];
        this.start_options.forEach((item,index)=>{
          if(item.value === start_at){
            start_at_index = index
          }
        })
        halfAnHour =start_at_index/2 !== Math.floor(start_at_index/2);
        //获取结束时间数组
        for(let i=Math.floor(start_at_index/2); i<24; i++){
          if(i===Math.floor(start_at_index/2)){
            if(!halfAnHour){
              end_options.push({
                value:`${i}:30`,
                label:`${i}:30`,
              })
            }
          }else{
            end_options.push({
              value:`${i}:00`,
              label:`${i}:00`,
            })
            end_options.push({
              value:`${i}:30`,
              label:`${i}:30`,
            })
          }
        }
        end_options.push({
          value:`24:00`,
          label:`24:00`,
        })

        if(updateEndAt && 48-start_at_index<=18){
          this.company_data.benefits.end_at = '24:00'
        }else if(updateEndAt){
          this.company_data.benefits.end_at = end_options[17].value
        }
        this.end_options = end_options;

      },
      //取消错误提示
      inputFocus(type){
        this.errorTips[type] = ''
      },
      //【福利】判断是否选中
      isCurrent(sitem,benefit_detail){
        let isCurrent = false;
        benefit_detail.length && benefit_detail.forEach(dItem=>{
          if(dItem.id === sitem.leve1_id){
            dItem.list.length && dItem.list.forEach(sDItem=>{
              if(sDItem.id === sitem.id){
                isCurrent = true
              }
            })
          }
        })
        return isCurrent
      },
      //【福利】删除某一个
      deleteBenefit(sitem){
        let { benefit_detail } = this.company_data.benefits;
        benefit_detail.length && benefit_detail.forEach(dItem=>{
          if(dItem.id == sitem.leve1_id){
            dItem.list.length && dItem.list.forEach((sDItem,sDIndex)=>{
              if(sDItem.id === sitem.id){
                dItem.list.splice(sDIndex, 1);
              }
            })
          }
        })
      },
      //【福利弹窗】点击删除/添加
      benefitChange(sitem){
        let isCurrent = false;
        let dIndex2 = -1;
        let sDIndex2 = -1;
        this.benefit_detail.length && this.benefit_detail.forEach((dItem,dIndex)=>{
          if(dItem.id === sitem.leve1_id){
            dIndex2 = dIndex
            dItem.list.length && dItem.list.forEach((sDItem,sDIndex)=>{
              if(sDItem.id === sitem.id){
                isCurrent = true;
                dItem.list.splice(sDIndex, 1);
              }
            })
          }
        })
        if(!isCurrent){
          this.benefit_detail[dIndex2].list.push({id:sitem.id})
        }
      },
      //【福利弹窗】关闭/显示
      saveBenefit(state){
        if(state){
          this.benefit_detail = JSON.parse(JSON.stringify(this.company_data.benefits.benefit_detail));
          this.showBenefitState = true;
          document.body.style.position = 'static'
          document.body.style.overflow = 'hidden'
        }else{
          this.company_data.benefits.benefit_detail = JSON.parse(JSON.stringify(this.benefit_detail));
          this.showBenefitState = false;
          document.body.style.position = 'initial'
          document.body.style.overflow = 'initial'
        }
      },
      //关闭弹窗
      closeBenefit(){
        this.showBenefitState = false;
        document.body.style.position = 'initial'
        document.body.style.overflow = 'initial'
      },
      //保存数据
      saveForm(){
        let { start_at, end_at, overtime, rest, benefit_detail } = this.company_data.benefits
        if(!start_at || !end_at){
          this.errorTips.time = '请选择工作时间';
          return false;
        }
        let benefit_detail2 = benefit_detail.filter((item)=>{
          return item.list.length
        })
        let data = {
          start_at,
          end_at,
          overtime,
          rest,
          benefit_detail:benefit_detail2
        };
        this.saveFormState = true;
        actions.company.put_company_benefits(this.company_data.token,data).then(res=>{
          this.saveFormState = false;
          if(res.code === 1000){
            let companyData = JSON.parse(JSON.stringify(this.companyData));
            companyData.benefits = this.company_data.benefits;
            //同步数据到vuex
            this.updateCompanyData(companyData)
            this.$message.success('公司福利修改成功');
          }else{
            this.$message({
              message:res.message,
              type:'error'
            })
          }
        })
      },

    },
    watch:{
      companyData :{
        handler: function (val, oldVal) {
          console.log('companyData2=>刷新数据',!_.isEqual(val.benefit, this.company_data.benefits))
          if(_.isEqual(val.benefit, this.company_data.benefits)){
            return false
          }
          this.company_data = JSON.parse(JSON.stringify(val));
          this.benefit_detail = JSON.parse(JSON.stringify(val.benefits.benefit_detail));
          this.getEndTimeOptions(false);
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './rightContent.scss';
</style>